// File: src/components/car/CarSpecificationsModal.jsx
import React, { useState } from 'react';
import './CarSpecificationsModal.css';


const CarSpecificationsModal = ({ isOpen, onClose, car, onBookNow, onTestDrive }) => {
  const [activeTab, setActiveTab] = useState('dimensions');
  if (!isOpen) return null;

  const specs = car?.car_specification || {};

  // Organize specifications by category
  const specCategories = {
    dimensions: {
      title: 'DIMENSIONS & CAPACITY',
      icon: '📐',
      items: [
        { label: 'Boot space', value: specs.boot_space, unit: 'litres' },
        { label: 'Number of seating rows', value: car.seating_capacity > 5 ? '3 units' : '2 units', unit: '' },
        { label: 'Wheelbase', value: specs.wheelbase, unit: 'mm' },
        { label: 'Length', value: specs.length, unit: 'mm' },
        { label: 'Alloy wheels', value: specs.alloy_wheels || 'Yes', unit: '' },
        { label: 'Front tyre size', value: specs.front_tyre_size, unit: '' },
        { label: 'Rear tyre size', value: specs.rear_tyre_size, unit: '' },
        { label: 'Number of doors', value: specs.number_of_doors || '5 units', unit: '' },
        { label: 'Height', value: specs.height, unit: 'mm' },
        { label: 'Width', value: specs.width, unit: 'mm' },
      ]
    },
    engine: {
      title: 'ENGINE & TRANSMISSION',
      icon: '⚙️',
      items: [
        { label: 'Drive train', value: specs.drive_train || 'Front Wheel Drive', unit: '' },
        { label: 'Gear box', value: specs.gear_box || '6-Speed', unit: '' },
        { label: 'Number of gears', value: specs.number_of_gears || '6 units', unit: '' },
        { label: 'Displacement', value: specs.engine_displacement, unit: 'cc' },
        { label: 'Number of cylinders', value: specs.number_of_cylinders || '4 units', unit: '' },
        { label: 'Valve/cylinder (configuration)', value: specs.valve_configuration || '4 units', unit: '' },
        { label: 'Turbocharger', value: specs.turbocharger || 'Yes', unit: '' },
        { label: 'Limited slip differential (LSD)', value: specs.lsd || 'No', unit: '' },
      ]
    },
    fuel: {
      title: 'FUEL & PERFORMANCE',
      icon: '⛽',
      items: [
        { label: 'Mileage (ARAI)', value: specs.mileage, unit: 'kmpl' },
        { label: 'Mileage (City)', value: specs.mileage_city || specs.mileage, unit: 'kmpl' },
        { label: 'Mileage (Highway)', value: specs.mileage_highway || specs.mileage, unit: 'kmpl' },
        { label: 'Max power (bhp)', value: specs.power, unit: 'bhp' },
        { label: 'Max torque (Nm)', value: specs.torque, unit: 'Nm' },
        { label: 'Emission class', value: specs.emission_class || 'BS6', unit: '' },
        { label: 'Fuel tank capacity', value: specs.fuel_tank_capacity, unit: 'litres' },
      ]
    },
    suspension: {
      title: 'SUSPENSION, STEERING & BRAKES',
      icon: '🔧',
      items: [
        { label: 'Ground clearance', value: specs.ground_clearance, unit: 'mm' },
        { label: 'Steering type', value: specs.steering_type || 'Electric Power Steering', unit: '' },
        { label: 'Turning radius', value: specs.turning_radius, unit: 'metres' },
        { label: 'Front brake type', value: specs.front_brake_type || 'Disc', unit: '' },
        { label: 'Rear brake type', value: specs.rear_brake_type || 'Drum', unit: '' },
        { label: 'Front suspension', value: specs.front_suspension || 'MacPherson Strut', unit: '' },
        { label: 'Rear suspension', value: specs.rear_suspension || 'Twist Beam', unit: '' },
      ]
    }
  };

  const tabs = [
    { id: 'dimensions', label: 'Dimensions & capacity' },
    { id: 'engine', label: 'Engine & transmission' },
    { id: 'fuel', label: 'Fuel & performance' },
    { id: 'suspension', label: 'Suspension, steering & brakes' }
  ];

  const handleTestDrive = () => {
    onClose();
    if (onTestDrive) onTestDrive();
  };

  const handleBookNow = () => {
    onClose();
    if (onBookNow) onBookNow();
  };

  

  return (
    <div className="spec-modal-overlay" onClick={onClose}>
      <div className="spec-modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="spec-modal-header">
          <button className="spec-modal-back" onClick={onClose}>
            ← Specifications
          </button>
          <div className="spec-modal-search">
            <input 
              type="text" 
              placeholder="Search any features" 
              className="spec-search-input"
            />
            <span className="spec-search-icon">🔍</span>
          </div>
        </div>

        {/* Tabs */}
        <div className="spec-modal-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`spec-modal-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="spec-modal-content">
          <div className="spec-modal-section">
            <h3 className="spec-modal-section-title">
              <span className="spec-section-icon">
                {specCategories[activeTab].icon}
              </span>
              {specCategories[activeTab].title}
            </h3>

            <div className="spec-modal-grid">
              {specCategories[activeTab].items.map((item, index) => {
                if (!item.value) return null;
                
                return (
                  <div key={index} className="spec-modal-item">
                    <div className="spec-item-content">
                      <span className="spec-item-label">{item.label}</span>
                      <span className="spec-item-value">
                        {item.value} {item.unit}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="spec-modal-footer">
          <button className="spec-footer-btn book-now" onClick={handleBookNow}>
            BOOK NOW
            <span className="btn-subtitle">100% refundable</span>
          </button>
          <button className="spec-footer-btn test-drive" onClick={handleTestDrive}>
            FREE TEST DRIVE
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarSpecificationsModal;